import React from 'react';
import { ScrollReveal } from './ScrollReveal';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = ['Plantilla para crear tu producto en 24 horas', 'Guiones listos para reels de venta', 'Checklist de lanzamiento en 5 días', 'Script de cierre por DM', 'Calculadora de precio y margen'];
  return <section className="py-20 px-4 bg-[#050510] relative overflow-hidden" data-id="element-14">
      {/* Background glow */}
      <div className="absolute bottom-0 left-0 w-full h-full bg-gradient-to-t from-purple-900/10 to-transparent pointer-events-none" data-id="element-15" />

      <div className="container mx-auto max-w-6xl relative z-10" data-id="element-16">
        <ScrollReveal className="text-center mb-16" data-id="element-17">
          <span className="text-purple-400 font-bold tracking-wider text-sm uppercase mb-2 block" data-id="element-18">
            Regalos Exclusivos
          </span>
          <h2 className="text-3xl md:text-5xl font-bold" data-id="element-19">
            Bonos Incluidos GRATIS
          </h2>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 justify-center" data-id="element-20">
          {bonuses.map((bonus, index) => <ScrollReveal key={index} delay={index * 0.1} direction="up" data-id="element-21">
              <div className="glass-card p-6 rounded-xl border border-purple-500/20 hover:border-purple-500/50 transition-all duration-300 group h-full flex flex-col items-center text-center" data-id="element-22">
                <div className="w-12 h-12 bg-purple-500/20 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300" data-id="element-23">
                  <Gift className="w-6 h-6 text-purple-400" data-id="element-24" />
                </div>
                <h3 className="text-lg font-medium text-white" data-id="element-25">{bonus}</h3>
              </div>
            </ScrollReveal>)}
        </div>
      </div>
    </section>;
}